import { fetcher } from "src/utils/fetcher";
import isBrowser from "src/utils/isBrowser";

export type AppData = {
  id: number;
  slug: string;
  name: string;
  image: string;
  is_public: boolean;
  current_implementation_id: string;
};

export type SearchAppsResponse = {
  results: Array<AppData>;
};

export const searchApps = async (params?: Record<string, string>) => {
  try {
    const path = params && params.slugs ? "/api/v4/services" : "/api/v4/apps";
    const url = new URL(
      path,
      isBrowser()
        ? window.location.origin
        : process.env.NEXT_PUBLIC_ZAPIER_ORIGIN,
    );
    url.search = new URLSearchParams({
      limit: "10",
      ...params,
    }).toString();

    const { results } = await fetcher<SearchAppsResponse>(url.toString());

    return results;
  } catch (error: unknown) {
    console.error("Failed to get search results", error);
    return [];
  }
};
